import React, { Component } from "react";

import {
  Grid,
  Container,
  Paper,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import refresh_token from "./../../../Global/refresh_token";
import GlobalApi from "./../../../Global";
import Button from "@material-ui/core/Button";
import Colors from "./../../../Global/colors";
import DarkButton from "./../../../Global/DarkButton";

import TextInput from "./TextInput";
export default class Header extends Component {
  state = {
    title: "",
    description: "",
    edit: false,
    loader: false,
  };

  componentDidMount() {
    this.setState({
      title: this.props.title,
      description: this.props.description,
      template_id: this.props.template_id,
      status: "active",
    });
  }

  async handleEditToggle(edit) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    if (edit === false) {
      this.setState({ edit: true });
    } else {
      let req = await fetch(GlobalApi + "/Template/edit_template", {
        method: "Post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(this.state),
      });

      let reqJson = await req.json();
      if (reqJson.status === "Success") {
        this.setState({ edit: false, loader: false });
      } else if (
        reqJson.error === "jwt expired" ||
        reqJson.error === "invalid token" ||
        reqJson.error === "invalid signature" ||
        reqJson.error === "Unexpected token"
      ) {
        let status = await refresh_token();
        if (status) {
          this.handleEditToggle(edit);
        }
      }
    }
  }

  handleChange = (event) => {
    let { value, name } = event.target;

    this.setState({
      [name]: value,
    });
  };

  render() {
    let { title, description, edit, loader } = this.state;
    return (
      <Paper
        style={{ width: "100%", marginBottom: 10 }}
        className=" p-5"
        variant="outlined"
      >
        <Grid
          container
          className="temp-cont"
          justifyContent="center"
          alignItems="center"
        >
          {edit === true ? (
            <Grid item xs={12} sm={11}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <TextInput
                    label="Title"
                    name="title"
                    value={title}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextInput
                    label="Description"
                    name="description"
                    value={description}
                    onChange={this.handleChange}
                    multiline
                  />
                </Grid>
              </Grid>
            </Grid>
          ) : (
            <Grid item xs={8} sm={10}>
              <Typography variant="h6">{title}</Typography>
              <Typography variant="p">{description}</Typography>
            </Grid>
          )}
          {edit === true ? (
          <Grid item xs={12} sm={1} align="right">
              <>
                {/* for Web and Tab */}
                {window.innerWidth > 500 ? (
                  <>
                    <Button
                      variant="contained"
                      type="submit"
                      className="addBtn"
                     
                      onClick={() => {
                        if (loader === false) {
                          this.setState({ loader: true });
                          this.handleEditToggle(edit);
                        }
                      }}
                      style={{
                        backgroundColor: Colors.globalColor8,
                        width: "80px",
                      }}
                    >
                      {loader === true && (
                        <CircularProgress
                          size={18}
                          style={{ color: "white", marginRight: 7 }}
                        />
                      )}
                      Save
                    </Button>
               
                    
                   

                    <Button
                      variant="contained"
                      className="cancelBtn"
                      style={{ width: "80px", marginTop:window.innnerWidth > 500 ? "5px" : "0px" }}
                      onClick={() => {
                        this.setState({
                          edit: false,
                          loader: false,
                          title: this.props.title,
                          description: this.props.description,
                        });
                      }}
                    >
                      Cancel
                    </Button>
                  </>
                ) : (
                  <Grid container style={{padding:'10px 12px 0px 2px'}} spacing={2}>
                    <Grid item xs={6}>
                      <Button
                        variant="contained"
                        type="submit"
                        className="addBtn"
                        component="span"
                        onClick={() => {
                          if (loader === false) {
                            this.setState({ loader: true });
                            this.handleEditToggle(edit);
                          }
                        }}
                        style={{
                          backgroundColor: Colors.globalColor8,
                          width: "100%",
                        }}
                      >
                        {loader === true && (
                          <CircularProgress
                            size={18}
                            style={{ color: "white", marginRight: 7 }}
                          />
                        )}
                        Save
                      </Button>
                    </Grid>
                    <Grid item xs={6}>
                      <Button
                        variant="contained"
                        className="cancelBtn"
                        style={{ width: "100%",  marginTop:window.innnerWidth > 500 ? "5px" : "0px" }}
                        onClick={() => {
                          this.setState({
                            edit: false,
                            loader: false,
                            title: this.props.title,
                            description: this.props.description,
                          });
                        }}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </>
          </Grid>) : <Grid item xs={4} sm={2} align="right" style={{justifyContet:"flex-end"}}>
              <Button
                variant="contained"
                type="submit"
                className="addBtn"
                component="span"
                onClick={() => this.handleEditToggle(edit)}
                style={{ backgroundColor: Colors.globalColor8 }}
              >
                {"Edit"}
              </Button>
          
          </Grid>}
        </Grid>
      </Paper>
    );
  }
}
